// components/ConnectionAlerts.jsx
import { Alert, Button, Box, CircularProgress } from '@mui/material';
import { Circle, Refresh } from '@mui/icons-material';

const ConnectionAlerts = ({
  isConnected,
  isConnecting,
  disconnectReason,
  onConnect
}) => {
  if (isConnected) return null;

  return (
    <>
      {!isConnecting && !disconnectReason && (
        <Alert 
          severity="info" 
          sx={{ mb: 2 }}
          action={
            <Button 
              color="inherit" 
              size="small" 
              onClick={onConnect}
              startIcon={<Circle />}
            >
              連接戰情室
            </Button>
          }
        >
          點擊右側按鈕連接到戰情室開始即時交流
        </Alert>
      )}

      {isConnecting && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={16} />
            正在連線到聊天室，請稍候...
          </Box>
        </Alert>
      )}

      {disconnectReason && (
        <Alert 
          severity="error" 
          sx={{ mb: 2 }}
          action={
            <Button 
              color="inherit" 
              size="small" 
              onClick={onConnect}
              startIcon={<Refresh />}
            >
              重新連線
            </Button>
          }
        >
          {disconnectReason}
        </Alert>
      )}
    </>
  );
};

export default ConnectionAlerts;